import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingIndicator = () => {
    return (<div>
        <CircularProgress />
    </div>);
};

export default LoadingIndicator;
